import { CloudDownloadOutlined, CopyOutlined } from "@ant-design/icons";
import { ProForm } from "@ant-design/pro-components";
import { Divider, QRCode, Statistic } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CustomButton, CustomCard, CustomInput, toast } from "../../../../components";
import { useLoading } from "../../../../context/LoadingContext";
import { useMobile } from "../../../../context/MobileContext";
import { useModal } from "../../../../context/ModalContext";
import { apiCodeEnum } from "../../../../enumerations/signInUpEnum";
import { moneyFormat } from "../../../../plugins/numberFormat";
import { copyText } from "../../../../plugins/utils";
import { usePostUpImg, usePostUpload } from "../../hooks/index.hook";
import styles from "./style.module.scss";
import "./style.scss";

const statusEnum = {
  PROCESSING: "0",
  FAIL: "1",
  SUCCESS: "2",
};

const Trade = () => {
  const { Countdown } = Statistic;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isMobile } = useMobile();
  const { state: data } = useLocation();
  const { setMainLoading } = useLoading();
  const { openTipsModal } = useModal();
  const [fileList, setFileList] = useState([]);
  const [imgUrl, setImgUrl] = useState();

  const { mutate: Upload, isLoading } = usePostUpload();
  const { mutate: UpImg, isLoading: upImgIsLoading } = usePostUpImg();

  const downloadCanvasQRCode = () => {
    function doDownload(url, fileName) {
      const a = document.createElement("a");
      a.download = fileName;
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL();
      doDownload(url, "QRCode.png");
    }
  };

  const handleFinish = () => {
    if (fileList.length <= 0) {
      openTipsModal({
        body: t("normal.pleaseUpload"),
      });
      return;
    }

    const form = new FormData();
    form.append("sn", data.sn);
    form.append("img", imgUrl.url);

    UpImg(
      {
        params: form,
      },
      {
        onSuccess: (success) => {
          const { code, msg, data } = success?.data;
          if (code === apiCodeEnum.ERROR) {
            openTipsModal({
              body: msg,
            });
            return;
          }
          toast({ content: msg, type: "success" });
          navigate("/user/recharge/record?tab=recharge&radioValue=record");
        },
        onError: () => {},
      },
    );
  };

  const handleUpload = (file) => {
    const form = new FormData();
    form.append("file", file.file);
    form.append("name", file.file.name);

    Upload(
      {
        params: form,
      },
      {
        onSuccess: (success) => {
          const { msg, data } = success?.data;
          let newFileList = [];
          newFileList = newFileList.concat([
            {
              name: file.file.name,
              uid: file.file.uid,
              status: "done",
              url: success.data.data.whole_url,
            },
          ]);
          setFileList(newFileList);
          setImgUrl(data);
          toast({ content: msg, type: "success" });
        },
        onError: () => {},
      },
    );
  };

  const renderTop = (
    <>
      <div>{t("wallet.amountArea.label")}</div>
      {/* <div className={styles.label}>{t("wallet.trade.predictMoney.label")}</div> */}
      <div className={styles.moneyContainer}>
        <div className={styles.predictMoney}>
          {(moneyFormat(data.predict_money, 2, 6) || 0) + " " + data?.name}
        </div>
        <CopyOutlined className={styles.copy} onClick={() => copyText(data.predict_money)} />
      </div>
      <div className={styles.hint}>{t("wallet.trade.predictMoney.hint")}</div>
      {/* <div className={styles.label}>{t("wallet.trade.money.label")}</div> */}
      <div
        className={styles.money}
        dangerouslySetInnerHTML={{
          __html: t("wallet.trade.predictMoney", {
            money: moneyFormat(data.money) || 0,
          }),
        }}
      />
      <div
        className={styles.money}
        dangerouslySetInnerHTML={{
          __html: t("wallet.trade.ratio", {
            ratio: data?.ratio,
          }),
        }}
      />
    </>
  );

  const renderContent = (
    <div className={styles.main}>
      <div className={styles.qrCodeArea} id="myqrcode">
        <div className={styles.qrCode}>
          <QRCode type={"canvas"} value={data?.address} size={140} bgColor="#fff" />
          {isMobile && (
            <CloudDownloadOutlined className={styles.downloadIcon} onClick={downloadCanvasQRCode} />
          )}
        </div>
        <div className={styles.dataContainer}>
          <div>
            <div>{t("wallet.trade.recipient")}</div>
            <div className={styles.addressContainer}>
              <div className={styles.address}>
                {isMobile
                  ? // ? middleEllipsis({
                    //     inputString: data?.address,
                    //     minStringLength: 32,
                    //     firstLetterLength: 24,
                    //     secondLetterLength: 5,
                    //   })
                    data?.address
                  : data?.address}
              </div>
              <CopyOutlined className={styles.copy} onClick={() => copyText(data?.address)} />
            </div>
            {/* <div className={styles.hint}>{t("wallet.trade.hint")}</div> */}
          </div>
        </div>
      </div>
      <ProForm
        onFinish={handleFinish}
        submitter={{
          render: () => (
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              type={"submit"}
              loading={upImgIsLoading}
            >
              {t("normal.paid")}
            </CustomButton>
          ),
        }}
      >
        <CustomInput
          type="upload"
          label={t("label.upload")}
          fileList={fileList}
          setFileList={setFileList}
          customRequest={handleUpload}
        />
      </ProForm>
    </div>
  );

  useEffect(() => {
    setMainLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (!data) return;
    console.log("data", data);
  }, [data]);
  useEffect(() => {
    if (!fileList) return;
    console.log("fileList", fileList);
  }, [fileList]);

  return (
    <div className={`${styles.trade} trade`}>
      <CustomCard>
        {renderTop}
        <Divider />
        {renderContent}
      </CustomCard>
    </div>
  );
};

export default Trade;
